// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pulseresult[data-v-51d5df0e]{\n  width: 146px;\n  height: 150px;\n  float: left;\n}\n\n", ""]);
// Exports
module.exports = exports;
